/* Nutrio: egerrel huzhato karusszel (Alfred 2026-09-27).
   "lehessen ugy gorgetni, hogy egerrel megfogom es ugy huzom: most erre nem tortenik semmi"

   A temaban a karusszel a swiffy-slider. Erintokepernyon mukodik a huzas, egerrel viszont
   nem: a bongeszo asztali gepen nem gorget huzasra, es a slider `slider-transform` modban
   nem is natívan gorgetheto elem, hanem eltolassal lapoz. Ezert:
     - ha a sav natívan gorgetheto (overflow-x), huzas kozben a scrollLeft-et mozgatjuk,
     - ha eltolassal lapoz, a huzas vegen a sajat "Kovetkezo" / "Elozo" gombjat nyomjuk meg.
   A huzas utani kattintast elnyeljuk, kulonben a termekre huzva megnyilna a termekoldal. */
(function () {
  var MOZDULAT = 8;    // ennyi pixel alatt meg kattintasnak szamit
  var LAPOZAS = 45;    // ennyi pixel felett lapoz egyet a nem gorgetheto slider

  function gorgetheto(el) {
    var ox = getComputedStyle(el).overflowX;
    return (ox === 'auto' || ox === 'scroll') && el.scrollWidth > el.clientWidth + 4;
  }

  function bekot(slider) {
    if (slider.dataset.nutrioDrag) return;
    slider.dataset.nutrioDrag = '1';
    var sav = slider.querySelector('.slider-container') || slider;
    var huz = false, kezdX = 0, kezdScroll = 0, mozgott = 0;

    sav.style.cursor = 'grab';

    sav.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (e.target.closest('button, input, select, [role="button"]')) return;
      huz = true; mozgott = 0;
      kezdX = e.clientX;
      kezdScroll = sav.scrollLeft;
      sav.style.cursor = 'grabbing';
    });

    window.addEventListener('pointermove', function (e) {
      if (!huz) return;
      var dx = e.clientX - kezdX;
      if (Math.abs(dx) > mozgott) mozgott = Math.abs(dx);
      if (mozgott > MOZDULAT) {
        if (gorgetheto(sav)) sav.scrollLeft = kezdScroll - dx;
        if (window.getSelection) window.getSelection().removeAllRanges();
      }
    });

    window.addEventListener('pointerup', function (e) {
      if (!huz) return;
      huz = false;
      sav.style.cursor = 'grab';
      var dx = e.clientX - kezdX;
      if (Math.abs(dx) < MOZDULAT) return;          // ez kattintas volt
      slider.dataset.nutrioDragged = '1';
      setTimeout(function () { delete slider.dataset.nutrioDragged; }, 350);
      if (gorgetheto(sav)) return;                  // mar elgorgettuk huzas kozben
      if (Math.abs(dx) < LAPOZAS) return;
      var gomb = slider.querySelector(dx < 0 ? '.slider-nav-next, [aria-label="Következő"]'
                                             : '.slider-nav-prev, [aria-label="Előző"]');
      if (!gomb) {
        var gombok = slider.querySelectorAll('button[aria-label]');
        gomb = dx < 0 ? gombok[gombok.length - 1] : gombok[0];
      }
      if (gomb) gomb.click();
    });

    // huzas utani kattintas elnyelese (kulonben megnyilna a termek)
    sav.addEventListener('click', function (e) {
      if (slider.dataset.nutrioDragged) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    sav.addEventListener('dragstart', function (e) {
      if (e.target.tagName === 'IMG' || e.target.tagName === 'A') e.preventDefault();
    });
  }

  function indit() {
    document.querySelectorAll('.swiffy-slider').forEach(bekot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', indit);
  } else {
    indit();
  }
  // a Shopify szerkesztoben es a lusta betoltodesnel ujra bekotunk
  document.addEventListener('shopify:section:load', indit);
  new MutationObserver(function () { indit(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
